import { Component, Input } from '@angular/core';
import { CardCarousel } from './models/card-carousel.interfaces';

@Component({
  selector: 'idp-card-carousel',
  templateUrl: './card-carousel.component.html',
  styleUrls: ['./card-carousel.component.scss']
})
export class CardCarouselComponent {
  @Input() content: CardCarousel = {} as CardCarousel;
}
